let instance = null;

// Fonction pour définir l'instance (appelée par main.js une fois prêt)
export const setInstanceKeycloak = (keycloak) => {
    instance = keycloak;
};

// Fonction pour récupérer l'instance (appelée par le Router ou Axios)
export const getInstanceKeycloak = () => {
    if (!instance) {
        throw new Error("Keycloak n'a pas été initialisé !");
    }
    return instance;
};